import angular from 'angular';
import { Registration } from '../model/registration';
import { getFirstSelectedInvoiceStream } from '@/shared/components/registration/registrationHelpers';
import { isRecurrenceValid } from '@/shared/components/registration/recurrenceHelpers';
angular
  .module('cxRegistrations')
  .controller('AbsenceDialogCtrl', [
    '$element',
    'dataCache',
    'resourceFactorySvc',
    'flySvc',
    'dialogsSvc',
    'close',
    'registration',
    'settings',
    'invoiceStreamNamesSvc',
    absenceDialogCtrl,
  ]);
function absenceDialogCtrl(
  $element,
  dataCache,
  resourceFactorySvc,
  flySvc,
  dialogsSvc,
  close,
  registration,
  settings,
  invoiceStreamNamesSvc,
) {
  var vm = this;
  vm.showValidation = false;
  vm.saving = false;
  vm.currentUser = dataCache.getArray('employee')?.userID;

  vm.registration = new Registration({ type: 3 });
  if (registration) {
    if (registration instanceof Object) {
      vm.registration = new Registration(registration);
    }
  }

  vm.settings = settings || {};

  vm.canSave = () => {
    const { resource, recurrence, date, durationDays, fromMinutes, toMinutes } = vm.registration;
    if (!resource) return false;
    if (!recurrence) return true;
    return isRecurrenceValid(recurrence, date) && (durationDays > 0 || toMinutes > fromMinutes);
  };

  var registrationResource = resourceFactorySvc.get('registration');
  resourceFactorySvc
    .get('relation')
    .names({ take: 20, includeInactive: false, crmTypes: [4] }, function(data) {
      vm.relations = data;
      if (data.length === 0) return;
      if (data.length === 1) {
        vm.registration.relation = data[0];
      } else if (!vm.registration.relation) {
        const relationId = dataCache.getAbsenceRelationIdForUser(vm.registration.userId);
        const relation = relationId ? data.find(x => x.id === relationId) : null;
        vm.registration.relation = relation ?? data[0];
      }
    });

  vm.save = function() {
    if (!vm.canSave()) return;
    if (vm.saving) return;
    vm.saving = true;
    if (vm.registration.group)
      return registrationResource.update([vm.registration]).$promise.then(
        function(result) {
          vm.saving = false;
          $element.modal('hide');
          close(result[0], 500);
        },
        function(error) {
          flySvc.error(error);
          vm.saving = false;
        },
      );
    else
      return registrationResource.save([vm.registration]).$promise.then(
        function(result) {
          vm.saving = false;
          $element.modal('hide');
          close(result[0], 500);
        },
        function(error) {
          flySvc.error(error);
          vm.saving = false;
        },
      );
  };

  vm.selectRelation = function(relation) {
    if (!relation || !relation.id) {
      vm.registration.relation = null;
      return;
    }
    vm.registration.relation = relation;
    //Provisional default until the relation's invoice streams are loaded
    vm.registration.invoiceStream = null;
    vm.registration.invoiceStreamId = relation.invoiceStreamId || null;
    invoiceStreamNamesSvc.get(relation.id).then(function(streams) {
      //Ignore stale responses when the relation changed in the meantime
      if (vm.registration.relation !== relation) return;
      if (!streams || !streams.length) {
        //Relation without invoice streams cannot be registered on
        flySvc.warning('msgCannotSelectRelationWithoutInvoiceStreams');
        vm.registration.relation = null;
        vm.registration.invoiceStream = null;
        vm.registration.invoiceStreamId = null;
        return;
      }
      vm.registration.invoiceStream = getFirstSelectedInvoiceStream(
        streams,
        relation.invoiceStreamId,
      );
      vm.registration.invoiceStreamId = vm.registration.invoiceStream?.id;
    });
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
